import React from "react";
import { Edit } from "lucide-react";

export default function FinanceMobileSummaryCards({
  currentBudget,
  isTeacher,
  onOpenBudget,
  stats,
}) {
  return (
    <div className="grid grid-cols-2 gap-3">
      <div className="bg-white p-4 rounded-3xl shadow-sm border border-gray-100 flex flex-col items-center justify-center gap-1.5 text-center">
        <span className="text-xs font-bold text-gray-400">이번 달 수입</span>
        <span className="font-black text-blue-500 text-xl">{stats.monthlyIncome.toLocaleString()}</span>
      </div>
      <div className="bg-white p-4 rounded-3xl shadow-sm border border-gray-100 flex flex-col items-center justify-center gap-1.5 text-center">
        <span className="text-xs font-bold text-gray-400">이번 달 지출</span>
        <span className="font-black text-rose-500 text-xl">{stats.monthlyExpense.toLocaleString()}</span>
      </div>

      <div
        onClick={() => !isTeacher && onOpenBudget()}
        className={`bg-white p-4 rounded-3xl shadow-sm border-2 border-dashed border-gray-200 flex flex-col items-center justify-center gap-1.5 text-center relative overflow-hidden transition-all ${isTeacher ? "cursor-default opacity-70" : "active:scale-[0.98] cursor-pointer group hover:bg-gray-50 hover:border-gray-300"}`}
      >
        {!isTeacher && <div className="absolute top-2 right-2 text-gray-300 group-hover:text-gray-500 transition-colors"><Edit size={14} /></div>}
        <div className="flex items-center text-xs font-bold text-gray-400">
          연간 예산
        </div>
        <span className={`font-black text-gray-800 text-xl ${!isTeacher && "group-hover:underline decoration-2 decoration-gray-200 underline-offset-4"} transition-all`}>
          {Number(currentBudget).toLocaleString()}
        </span>
      </div>

      <div className="bg-white p-4 rounded-3xl shadow-sm border border-gray-100 flex flex-col items-center justify-center gap-1.5 text-center">
        <span className="text-xs font-bold text-gray-400">남은 예산</span>
        <span className={`font-black text-xl ${(currentBudget - stats.totalExpense) >= 0 ? "text-emerald-600" : "text-rose-600"}`}>
          {(currentBudget - stats.totalExpense).toLocaleString()}
        </span>
      </div>
    </div>
  );
}
